import Image from "next/image";
import getSmarterLogo from "@/public/images/getsmarter-logo.svg";
import useTranslations from "@/i18n/useTranslations";

interface Props {
  courseDisclaimer: string;
}

const GetSmarterLogo = ({ courseDisclaimer }: Props) => {
  const t = useTranslations("Common");
  return (
    <div className="flex flex-col md:flex-row md:items-center md:space-x-4 mt-6">
      <Image
        src={getSmarterLogo}
        alt={t("certificateLogoAlt")}
        className="w-32 h-18 mb-4 object-fill"
        width={100}
        height={100}
      />
      <span className="text-xs text-gray-500">
        This {courseDisclaimer} is offered by&nbsp;
        <a href="#whygetsmarter" className="underline">
          GetSmarter
        </a>
        , an edX partner.
      </span>
    </div>
  );
};

export default GetSmarterLogo;
